import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import cartAnalytics from '../Selection/cartAnalytics';
import Button from '../Elements/Button/Button';
import FakeSelect from '../Elements/FakeSelect/FakeSelect';
import NotifyMe from '../Header/NotifyMe';
import { addEvent, removeEvent, addClass, removeClass } from '../../utils/dom';
import { translate } from '../../utils/locale';
import { splitNewLine } from '../../utils/string';
import { addToBag } from '../../actions/checkout';
import s from './Purchase.scss';

class Purchase extends Component {
	constructor(props) {
		super(props);

		const { sizes } = props;

		this.state = {
			formError: false,
			formErrorHover: false,
			selected: sizes.length === 1 ? sizes[0].item : false,
			itemBeingAdded: false,
			itemAdded: false,
			itemAddedError: false,
			notifyMeOpen: false,
		};

		this.formElement = React.createRef();
	}

	componentDidMount() {
		addEvent(document.querySelector('body'), 'click.clearFormError', (e) => {
			if (this.formElement.current && !this.formElement.current.contains(e.target) && this.state.formError) {
				e.stopPropagation();
				e.preventDefault();
				this.setState({
					formError: false,
				});
			}
		});

		addEvent(window, 'keydown.clearFormError', (e) => {
			if (e.key === 'Escape') {
				this.setState({
					formError: false,
				});
			}
		});
	}

	componentWillUnmount() {
		removeEvent(document.querySelector('body'), 'click.clearFormError');
		removeEvent(window, 'keydown.clearFormError');
		removeClass(document.body, 'u_addedToBag');
	}

	toggleNotifyMeHandler = (isOpen) => {
		if (isOpen) {
			this.setState({ notifyMeOpen: true });
		} else {
			this.setState({ notifyMeOpen: 'exiting' });
			setTimeout(() => {
				this.setState({ notifyMeOpen: false });
			}, 350);
		}
	}

	addToBagHandler = (e) => {
		e.preventDefault();
		const { setup, cache, productVariantLookup, cachedProduct, originalProduct, currentPath, sizes, soldOut, checkout } = this.props;
		let { selected } = this.state;
		const isNotifyMe = !cachedProduct.limitedEdition && (soldOut || sizes.filter((size) => size.item === selected && size.stock === 0)).length > 0;
		const isBundle = originalProduct?.metafields?.bundle;
		const currentCategory = currentPath.slice(0, currentPath.lastIndexOf('/'));
		let cachedItems = [cachedProduct];

		if (isNotifyMe) {
			this.setState({ notifyMeOpen: true });
			return;
		}

		if (isBundle) {
			cachedItems = splitNewLine(isBundle).filter((item) => cache[productVariantLookup[item]]).map((item) => cache[productVariantLookup[item]]);
			selected = splitNewLine(isBundle).filter((item) => cache[productVariantLookup[item]]).map((item) => `gid://shopify/ProductVariant/${item}`);
		}

		// All sizes must be added for purchase to be successful.
		if (selected) {
			this.setState({ itemBeingAdded: true });

			if (cachedProduct.sizes.length === 1 && !Array.isArray(selected)) selected = cachedProduct.sizes[0].id;
			if (!Array.isArray(selected)) selected = [selected];

			const lines = [];

			selected.forEach((selectedItem) => {
				lines.push({
					merchandiseId: selectedItem,
					quantity: 1,
				});
			});

			this.props.addToBag(lines, cachedItems, currentCategory).then((response) => {
				this.setState({
					itemBeingAdded: false,
					itemAdded: true,
				});

				cartAnalytics(lines, cache, productVariantLookup, setup, currentCategory, response.data, checkout.listItemCache);

				window.setTimeout(() => {
					addClass(document.body, 'u_addedToBag');

					window.setTimeout(() => {
						removeClass(document.body, 'u_addedToBag');
					}, 4000);

					window.setTimeout(() => {
						this.setState({ itemAdded: false });
						this.setState({ selected: sizes.length === 1 ? cachedProduct.sizes[0].id : false });
					}, 2000);
				}, 200);
				return true;
			}).catch(() => {
				this.setState({ itemAddedError: true });

				window.setTimeout(() => {
					this.setState({ itemAddedError: false });
				}, 2000);
			});

			return;
		}

		this.setState({
			formError: true,
		});
	}

	selectSizeHandler = (item) => {
		this.setState({
			formError: false,
			selected: item,
		});
	}

	addToBagMouseEnterHandler = () => {
		const { selected } = this.state;

		if (!selected) {
			this.setState({
				formErrorHover: true,
			});
		}
	}

	addToBagMouseLeaveHandler = () => {
		this.setState({
			formErrorHover: false,
		});
	}

	render() {
		const { setup, cachedProduct, sizes, soldOut } = this.props;
		const { formError, formErrorHover, selected, itemBeingAdded, itemAdded, itemAddedError, notifyMeOpen } = this.state;
		const formattedSizes = sizes.map((item) => ({
			key: item.item,
			value: item.name,
			disabled: item.stock === 0,
			selected: selected === item.item,
		}));
		const isNotifyMe = !cachedProduct.limitedEdition && (soldOut || sizes.filter((size) => size.item === selected && size.stock === 0)).length > 0;

		let buttonText = formError || formErrorHover ? translate(setup, 'chooseSize') : translate(setup, 'itemAdd');
		if (soldOut) buttonText = translate(setup, 'soldOut');
		if (isNotifyMe) buttonText = translate(setup, 'notifyMe');
		if (itemAdded) buttonText = translate(setup, 'itemAdded');
		if (itemAddedError) buttonText = translate(setup, 'itemAddedError');
		if (itemBeingAdded) buttonText = translate(setup, 'itemBeingAdded');

		return (
			<>
				<form className={s.purchase} onSubmit={this.addToBagHandler} ref={this.formElement}>
					{
						sizes.length > 1 && (
							<div className={s.purchase_choice}>
								<FakeSelect open={formError && soldOut === false && !selected} disabled={soldOut !== false} items={formattedSizes} title={translate(setup, 'chooseSize')} selectionHandler={this.selectSizeHandler} />
							</div>
						)
					}
					<div className={[s.purchase_submit, (soldOut ? s.purchase_submit__soldOut : null)].join(' ')}>
						<Button variantClasses={['button__purchase']} disabled={soldOut !== false && !isNotifyMe} text={buttonText} mouseEnterEventHandler={this.addToBagMouseEnterHandler} mouseLeaveEventHandler={this.addToBagMouseLeaveHandler} />
					</div>
				</form>
				{
					notifyMeOpen !== false && <NotifyMe cachedProduct={cachedProduct} notifyMeState={notifyMeOpen} toggleNotifyMe={this.toggleNotifyMeHandler} />
				}
			</>
		);
	}
}

const mapState = ({ checkout }, props) => ({
	checkout,
	...props,
});

export default hot(module)(connect(mapState, { addToBag })(Purchase));
